import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IPolicy, PolicyType } from '../_models/policy.model';
import { PolicyService } from '../_services/policy.service';
import { SeoService } from '../../_shared/_services/seo.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    imports: [AsyncPipe]
})
export class PrivacyPolicyComponent implements OnInit {
  private readonly policyService = inject(PolicyService);
  private readonly seoService = inject(SeoService);

  public policies$!: Observable<Array<IPolicy>>;
  public privacy: PolicyType = PolicyType.PRIVACY;

  ngOnInit(): void {
    this.seoService.createCanonicalUrl('https://mypoolhut.com/policy/privacy-policy');
    this.policies$ = this.policyService.policies$;
    this.policyService.loadPolicies();
  }

}
